import React, { useEffect, useState } from 'react';
import { useTheme } from '../ThemeContext';
import { getApiUrl } from '../utils/platform';
import { setClientId, setHomeownerToken, setUserTypePreference } from '../utils/storage';
import { HomeBuyerHistory, HomeTransferClaimForm, TransferWordmark } from './HomeTransferScreens';

async function publicPost(body) {
  const response = await fetch(getApiUrl('/.netlify/functions/home-transfer'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error((data && data.error) || 'The home could not be claimed.');
    error.status = response.status;
    throw error;
  }
  return data;
}

export default function HomeTransferClaim({ token }) {
  const { colors } = useTheme();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState('');
  const [home, setHome] = useState(null);
  const page = {
    minHeight: '100vh',
    background: colors.background,
    color: colors.text,
    padding: '1.25rem',
    boxSizing: 'border-box',
  };

  useEffect(() => {
    let cancelled = false;
    publicPost({ action: 'meta', token })
      .then((data) => {
        if (!cancelled) setMeta(data || {});
      })
      .catch((err) => {
        if (!cancelled) setError((err && err.message) || 'This hand-off is no longer available.');
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  async function claim(fields) {
    const data = await publicPost({
      action: 'claim',
      token,
      accepted: true,
      name: fields.name,
      password: fields.password,
      sponsorChoice: fields.sponsorChoice,
      sponsorCode: fields.sponsorCode,
    });
    if (data && data.token) await setHomeownerToken(data.token);
    if (data && data.home && data.home.id) await setClientId(data.home.id);
    await setUserTypePreference('homeowner');
    setHome(data && data.home);
  }

  return (
    <main style={page}>
      <TransferWordmark color={colors.text} />
      {error ? <p role="alert">{error}</p> : null}
      {home ? (
        <div>
          <HomeBuyerHistory
            colors={colors}
            address={home.address}
            city={home.city}
            state={home.state}
            note={home.note}
            entries={home.entries}
          />
          <button
            type="button"
            onClick={() => { window.location.assign('/'); }}
            style={{
              background: '#59c4c4',
              color: '#fff',
              border: 'none',
              borderRadius: '0.5rem',
              minHeight: '44px',
              padding: '0.7rem 1rem',
              fontWeight: 650,
              marginTop: '0.5rem',
            }}
          >
            Open your home
          </button>
        </div>
      ) : null}
      {!home && meta ? (
        <HomeTransferClaimForm
          colors={colors}
          addressLabel={meta.addressLabel}
          onSubmit={claim}
        />
      ) : null}
      {!home && !meta && !error ? <p>Loading the hand-off.</p> : null}
    </main>
  );
}
